/**
 @author huangjiaojiao
 @date 2020/4/13 13:46 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
// 根据条件获取用户列表
export const getUser = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetUserList?"+ qs.stringify(data),
        method: "get",
    })
};
// 验证是否存在相同的组名称
export const GetGroupByGroupName = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetGroupByGroupName?"+ qs.stringify(data),
        method: "get",
    })
};
// 添加组信息
export const SetGroup = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/SetGroup?"+ qs.stringify(data),
        method: "get",
    })
};
// 获取当前用户创建的组列表
export const GetGroupList = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetGroupListByUserId",
        method: "get",
    })
};
// 移动添加组成员
export const SetGroupMembers = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/SetGroupMembers?"+ qs.stringify(data),
        method: "get",
    })
};